import { render, staticRenderFns } from "./TaskPreviewOptions.vue?vue&type=template&id=202cb407&scoped=true&"
import script from "./TaskPreviewOptions.vue?vue&type=script&lang=js&"
export * from "./TaskPreviewOptions.vue?vue&type=script&lang=js&"
import style0 from "./TaskPreviewOptions.vue?vue&type=style&index=0&id=202cb407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202cb407",
  null
  
)

export default component.exports